module.exports = __webpack_public_path__ + "img/loading_gif.b71b7d60.gif";